import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const getEmpTimeSheetSlice = createSlice({
  name: "TimeSheet",

  initialState: { empTimesheetData: [], timeSheetLoader: false },
  reducers: {
    setEmpTimeSheetData: (state: any, action: PayloadAction<any>) => {
      state.empTimesheetData = action.payload;
    },
    setTimeSheetLoader: (state: any, action: PayloadAction<any>) => {
      state.timeSheetLoader = action.payload;
    },
    resetEmpTimeSheetData: (state: any) => {
      state = [];
    },
  },
});

export const {
  setEmpTimeSheetData,
  resetEmpTimeSheetData,
  setTimeSheetLoader,
} = getEmpTimeSheetSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default getEmpTimeSheetSlice.reducer;
